import * as React from "react";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";

import "./App.css";
import Home from "./components/home/Home";
import Dashboard from "./components/dashboard/Dashboard";
import AddMedication from "./components/Addmedication";
import AddMedicationManual from "./components/AddMedicationManual";
import Medication from "./components/Medication";
import CheckSymptoms from "./components/Symptoms/CheckSymptoms";
import AskAdvice from "./components/askAdvice";
import OtpVerification from "./components/otp/otp";
import AddVitals from "./components/vital/addVital";
import Appointment from "./components/appointment";
import VitalSummary from "./components/vital/vitalSummary";
import ECGView from "./components/EcgView";
import MyHealth from "./components/MyHealth";
import Settings from "./components/settings/Settings";
import VideoCallPage from "./components/videoCallPage";
import Admin from "./components/admin/Admin";
import Landing from "./components/home/Landing";
import SignIn from "./components/signin";
import SignUp from "./components/signup";
import AdminAccess from "./components/admin/AdminAccess";
import { useEffect } from "react";
import { DoctorDetail } from "./components/consultant/doctorDetail";
import ScheduleAppointment from "./components/scheduleAppointment";

import Specialties from "./components/consultant/specialities";
import { AppointmentSummary } from "./components/consultant/appointmentSummary";
import { AppointmentForm } from "./components/consultant/appointmentForm";
import { AppointmentDetail } from "./components/consultant/appointmentDetail";
import VitalHistory from "./components/vital/vitalHistory";
import DocumentHistory from "./components/documentHistory";
import CDLanding from "./components/customerDeletion/cdLanding";
import DeleteForm from "./components/customerDeletion/deleteForm";
import DeleteSuccess from "./components/customerDeletion/DeleteSuccess";
import AppointmentRequest from "./components/AppointmentRequest";
import { AppointmentForm1 } from "./components/consultant/appointmentForm1";
import PatientReport from "./components/patientReport";
import AddFacilityPage from "./components/facility/addFacility";
import DocumentView from "./components/documentView";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "./components/notFound";
import Cookies from "js-cookie";

export default function App() {
  let navigate = useNavigate();
  const checkAuthentication = () => {
    const token = Cookies.get("consumerAccessToken"); // Get the token from sessionStorage or cookies
    const patientId = localStorage.getItem("patientId");
    return !!token && !!patientId;
  };
  useEffect(() => {
    // localStorage.setItem(
    //   "staticAccessToken",
    //   `${process.env.REACT_APP_STATICACCESSTOKEN}`
    // );
    // if (checkAuthentication()) {
    //   navigate("/Dashboard");
    // }
  }, []);
  return (
    <div className="App mx-auto max-w-mob relative">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/id/:userId" element={<Home />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="otp" element={<OtpVerification />} />
        <Route path="/deleteaccount" element={<CDLanding />} />
        <Route path="admin" element={<Admin />} />
        <Route path="adminAccess" element={<AdminAccess />} />
        <Route path="/patientReport" element={<PatientReport />} />
        <Route
          path="addMedication"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AddMedication />
            </ProtectedRoute>
          }
        />
        <Route
          path="vitalSummary"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <VitalSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="ecgView"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <ECGView />
            </ProtectedRoute>
          }
        />
        <Route
          path="myHealth"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <MyHealth />
            </ProtectedRoute>
          }
        />
        <Route
          path="AddMedicationManual"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AddMedicationManual />
            </ProtectedRoute>
          }
        />
        <Route
          path="Medication"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <Medication />
            </ProtectedRoute>
          }
        />
        <Route
          path="AskAdvice"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AskAdvice />
            </ProtectedRoute>
          }
        />
        <Route
          path="Settings"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <Settings />
            </ProtectedRoute>
          }
        />

        <Route
          path="videoCall"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <VideoCallPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/doctor/:doctorId"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <DoctorDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vitalHistory"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <VitalHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="specialties"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <Specialties />
            </ProtectedRoute>
          }
        />

        <Route
          path="schedule"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <ScheduleAppointment />
            </ProtectedRoute>
          }
        />

        <Route
          path="/scheduleAppointment/:locationId"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AppointmentForm1 />
            </ProtectedRoute>
          }
        />
        <Route
          path="/scheduleAppointment/:locationId/1"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AppointmentForm />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointmentSummary/:locationId"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AppointmentSummary />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointmentDetail/:appointmentId"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AppointmentDetail />
            </ProtectedRoute>
          }
        />
        <Route
          path="/appointmentRequest"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AppointmentRequest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/documentView/:documentId"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <DocumentView />
            </ProtectedRoute>
          }
        />

        <Route
          path="Dashboard"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="CheckSymptoms"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <CheckSymptoms />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addFacility"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AddFacilityPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/documentHistory"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <DocumentHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="addVitals"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <AddVitals />
            </ProtectedRoute>
          }
        />

        <Route
          path="/delete/:id"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <DeleteForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/accountdeleted"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <DeleteSuccess />
            </ProtectedRoute>
          }
        />

        <Route
          path="/appointment"
          element={
            <ProtectedRoute isAllowed={checkAuthentication()} redirectTo="/">
              <Appointment />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <ProtectedRoute isAllowed={false} redirectTo="/">
              <NotFound />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}
